<div class="loader-overlay" *ngIf="loaderService.loading$ | async">
  <div class="spinner"></div>
</div>
